import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

const CATS = [
    { key: "all", label: "All" },
    { key: "individuals", label: "Individuals" },
    { key: "families", label: "Families" },
    { key: "couples", label: "Couples" },
    { key: "children", label: "Children" },
    { key: "latin", label: "Latin" },
];

const Prayers = () => {
    const [prayers, setPrayers] = useState([]);
    const [cat, setCat] = useState("all");

    useEffect(() => {
        const params = cat === "all" ? {} : { category: cat };
        api.get("/prayers", { params }).then(r => setPrayers(r.data));
    }, [cat]);

    return (
        <div className="max-w-6xl mx-auto px-6 md:px-10 py-16" data-testid="prayers-page">
            <div className="text-center mb-12">
                <div className="small-caps text-xs text-muted-foreground mb-3">The Shared Library</div>
                <h1 className="font-serif text-4xl md:text-5xl">Prayers</h1>
                <p className="mt-6 max-w-2xl mx-auto text-muted-foreground italic">
                    “Prayer is nothing else than being on terms of friendship with God.” — St. Teresa of Ávila
                </p>
            </div>

            <div className="flex items-center justify-center gap-1 flex-wrap mb-12" data-testid="prayer-filters">
                {CATS.map(c => (
                    <button key={c.key} onClick={() => setCat(c.key)} data-testid={`filter-${c.key}`}
                        className={`px-4 py-2 text-xs small-caps border ${cat===c.key ? 'border-liturgy accent-liturgy' : 'border-border text-muted-foreground hover:accent-liturgy'}`}>
                        {c.label}
                    </button>
                ))}
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-testid="prayers-grid">
                {prayers.map(p => (
                    <Link key={p.id} to={`/prayers/${p.slug}`} data-testid={`prayer-${p.slug}`} className="missal-card p-8 hover-lift block group">
                        <div className="flex items-start justify-between mb-3">
                            <div className="small-caps text-[11px] accent-liturgy">{p.category}</div>
                            <div className="small-caps text-[10px] text-muted-foreground">EN · ES · LA</div>
                        </div>
                        <h3 className="font-serif text-2xl mb-2 group-hover:accent-liturgy transition-colors">{p.title.en}</h3>
                        <p className="text-sm text-muted-foreground italic leading-relaxed">{p.description}</p>
                        <div className="mt-6 text-xs accent-liturgy">Pray this →</div>
                    </Link>
                ))}
                {prayers.length === 0 && <div className="col-span-2 text-center text-muted-foreground py-16">No prayers here yet — more are coming.</div>}
            </div>
        </div>
    );
};

export default Prayers;
